// extracted by mini-css-extract-plugin
export var blockedMessage = "_84-3";
export var blockedOverlay = "_84-1";
export var fadeIn = "_84-2";
export var hereLink = "_84-0";
export var slideUp = "_84-4";